function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#FileSQL_svg__clip0_1818_35632)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.727 2.578l3.21 3.215h-2.636a.576.576 0 01-.574-.574v-2.64z",
  fill: "#81D4FA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.442 2.578h8.285v2.625c0 .324.265.59.59.59h2.62v7.957c0 .215-.175.39-.39.39H4.442a.392.392 0 01-.39-.39V2.969c0-.215.175-.39.39-.39z",
  fill: "#B3E5FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.563 7.454h7.187v.625H6.562v-.625zM6.563 9.642h7.187v.625H6.562v-.625z",
  fill: "#039BE5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.295 11.974h13.41a.797.797 0 01.795.798v3.85a.797.797 0 01-.795.799H3.295a.797.797 0 01-.795-.798v-3.851a.797.797 0 01.795-.798z",
  fill: "#039BE5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.232 15.163l.687-.068c.04.231.124.4.251.509.126.107.296.162.511.162.227 0 .4-.048.514-.145a.428.428 0 00.173-.337.315.315 0 00-.073-.21.565.565 0 00-.254-.152 8.202 8.202 0 00-.565-.153c-.378-.094-.643-.21-.796-.346a.908.908 0 01-.322-.703.9.9 0 01.151-.5.952.952 0 01.437-.354c.19-.08.419-.12.687-.12.44 0 .77.095.992.287.22.193.337.45.349.77l-.706.032c-.03-.18-.095-.31-.194-.388-.1-.079-.249-.118-.447-.118-.205 0-.366.042-.482.127a.253.253 0 00-.112.216c0 .083.035.154.105.212.088.075.305.153.648.234.344.081.598.165.762.252a.988.988 0 01.387.355c.092.15.139.336.139.557a1.025 1.025 0 01-.64.952 1.975 1.975 0 01-.76.128c-.442 0-.781-.102-1.018-.306-.237-.205-.378-.503-.424-.893zm6.25.693c.172.124.36.223.564.296l-.26.498a1.616 1.616 0 01-.312-.13 14.443 14.443 0 01-.47-.31c-.23.1-.482.15-.76.15-.538 0-.959-.159-1.263-.475-.304-.316-.456-.76-.456-1.332 0-.572.152-1.015.457-1.333.305-.316.72-.475 1.243-.475.517 0 .928.159 1.232.475.303.318.455.761.455 1.333 0 .301-.042.567-.126.795a1.682 1.682 0 01-.305.508zm-.569-.398c.091-.106.159-.235.204-.386.045-.15.068-.324.068-.52 0-.404-.089-.705-.267-.904a.893.893 0 00-.698-.3c-.288 0-.521.1-.7.3-.18.2-.269.502-.269.905 0 .407.09.713.269.916.179.203.404.304.678.304a.828.828 0 00.289-.05 2.087 2.087 0 00-.437-.22l.198-.403c.232.08.454.199.665.358zm1.572.842v-3.467h.705v2.878h1.755v.589h-2.46z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "FileSQL_svg__clip0_1818_35632"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgFileSql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFileSql;